class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    if(this.id == "main-collection-filters-mobile"){
      setTimeout(() => {
        this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.onKeyUpEscape())
      });
    };
  }

  onKeyUpEscape() {
    removeTrapFocus(document.querySelector("[data-item='overlay-filter']"));
    rootAction.remove();
    this.classList.remove("active");
    this.removeAttribute("open");
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      const pathname =
        event.state?.pathname ||
        window.location.pathname;

      if (
        searchParams === FacetFiltersForm.searchParamsPrev &&
        pathname === FacetFiltersForm.pathnamePrev
      ) {
        return;
      }

      FacetFiltersForm.renderPage(
        searchParams,
        null,
        false,
        pathname
      );
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(
  searchParams,
  event,
  updateURLHash = true,
  pathname = window.location.pathname
) {
  const esenseraController =
    window.esenseraFullSearchController;

  if (
    esenseraController?.canHandleFacets?.()
  ) {
    /*
     * Ugyldiggør alle ældre native Shopify-facetrequests.
     *
     * Et allerede igangsat request kan ellers afslutte efter
     * den specialbyggede søgning og overskrive de aktive chips
     * med Shopifys native markup. Det er især synligt, når den
     * sidste produktfacet fjernes, fordi søgechippen så forsvinder.
     */
    ++FacetFiltersForm.renderRequestId;

    FacetFiltersForm.searchParamsPrev =
      searchParams;

    esenseraController.applyFacetSearchParams(
      searchParams,
      {
        updateHistory: updateURLHash
      }
    );

    /*
     * Fjern en eventuel loading-tilstand efter et request,
     * som netop er blevet gjort ugyldigt.
     */
    document
      .querySelectorAll(
        "#main-search-filters, " +
        "#main-collection-filters, " +
        "#main-collection-filters-mobile, " +
        ".facets-vertical"
      )
      .forEach((element) => {
        element.classList.remove(
          "loading",
          "start",
          "loaded",
          "finished"
        );
      });

    return;
  }

  /*
   * Hver AJAX-opdatering får et nummer.
   * Kun den seneste må opdatere siden.
   */
  const requestId =
    ++FacetFiltersForm.renderRequestId;

  FacetFiltersForm.searchParamsPrev =
    searchParams;

  FacetFiltersForm.pathnamePrev =
    pathname;

  const sections =
    FacetFiltersForm.getSections();

  const countContainer =
    document.getElementById("ProductCount");

  const countContainerDesktop =
    document.getElementById(
      "ProductCountDesktop"
    );

  document
    .getElementById("ProductContainer")
    .querySelector(".collection")
    .classList.add("loading");

  if (countContainer) {
    countContainer.classList.add("loading");
  }

  if (countContainerDesktop) {
    countContainerDesktop.classList.add(
      "loading"
    );
  }

  const filterCollection =
    document.getElementById(
      "main-collection-filters"
    );

  const filterCollectionMobile =
    document.getElementById(
      "main-collection-filters-mobile"
    );

  const filterSearch =
    document.getElementById(
      "main-search-filters"
    );

  if (filterCollection) {
    const filterCollectionVertical =
      filterCollection.closest(
        ".facets-vertical"
      );

    if (filterCollectionVertical) {
      if (window.innerWidth > 1024) {
        filterCollectionVertical.classList.add(
          "loading",
          "start"
        );
      }
    } else if (window.innerWidth > 1024) {
      filterCollection.classList.add(
        "loading",
        "start"
      );
    }
  }

  if (filterCollectionMobile) {
    filterCollectionMobile.classList.add(
      "loading",
      "start"
    );
  }

  if (
    filterSearch &&
    window.innerWidth > 1024
  ) {
    filterSearch.classList.add(
      "loading",
      "start"
    );
  }

  sections.forEach((section) => {
    const url =
      `${pathname}` +
      `?section_id=${section.section}` +
      `&${searchParams}`;

    const filterDataUrl =
      (element) => element.url === url;

    if (
      FacetFiltersForm.filterData.some(
        filterDataUrl
      )
    ) {
      FacetFiltersForm.renderSectionFromCache(
        filterDataUrl,
        event,
        requestId
      );
    } else {
      FacetFiltersForm.renderSectionFromFetch(
        url,
        event,
        requestId
      );
    }
  });

  if (updateURLHash) {
    FacetFiltersForm.updateURLHash(
      searchParams,
      pathname
    );
  }
}

  static renderSectionFromFetch(
  url,
  event,
  requestId
) {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      /*
       * Et nyere filter-request er startet.
       * Ignorér derfor dette gamle svar helt.
       */
      if (
        requestId !==
        FacetFiltersForm.renderRequestId
      ) {
        return;
      }

      const html = responseText;

      FacetFiltersForm.filterData = [
        ...FacetFiltersForm.filterData,
        {
          html,
          url
        }
      ];

      FacetFiltersForm.renderFilters(
        html,
        event
      );

      FacetFiltersForm.renderProductContainer(
        html
      );

      FacetFiltersForm.renderProductCount(
        html
      );

      if (
        typeof initializeScrollAnimationTrigger ===
        "function"
      ) {
        initializeScrollAnimationTrigger();
      }
    })
    .finally(() => {
      /*
       * Et gammelt request må heller ikke ændre
       * loading-tilstanden efter et nyere request.
       */
      if (
        requestId ===
        FacetFiltersForm.renderRequestId
      ) {
        initLazyloadItem();
      }
    });
}

  static renderSectionFromCache(
  filterDataUrl,
  event,
  requestId
) {
  if (
    requestId !==
    FacetFiltersForm.renderRequestId
  ) {
    return;
  }

  const html =
    FacetFiltersForm.filterData.find(
      filterDataUrl
    ).html;

  FacetFiltersForm.renderFilters(
    html,
    event
  );

  FacetFiltersForm.renderProductContainer(
    html
  );

  FacetFiltersForm.renderProductCount(
    html
  );

  if (
    typeof initializeScrollAnimationTrigger ===
    "function"
  ) {
    initializeScrollAnimationTrigger();
  }
}

  static renderProductContainer(html) {
    initLazyloadItem();
    document.getElementById('ProductContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductContainer').innerHTML;
    const htmlRender = new DOMParser().parseFromString(html, 'text/html');
    const collectionEmpty = htmlRender.querySelector('#ProductContainer .collection--empty');
    if (collectionEmpty) {
      rootAction.remove();
      const elementsToHide = document.querySelectorAll('.filter-product details, .filter-product .filter-count');
      elementsToHide.forEach(element => {
        element.classList.add('hidden');
      });
    } else {
      const elementsToHide = document.querySelectorAll('.filter-product details, .filter-product .filter-count');
      elementsToHide.forEach(element => {
        element.classList.remove('hidden');
      });
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop')?.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      if (count) container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      if (count) containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const filterCollection = document.getElementById('main-collection-filters');
    const filterCollectionMobile = document.getElementById('main-collection-filters-mobile');
    const filterSearch = document.getElementById('main-search-filters');

    if (filterCollection) {
      const filterCollectionVertical = filterCollection.closest(".facets-vertical");
      if (filterCollectionVertical) {
        if (window.innerWidth > 1024) {
          filterCollectionVertical.classList.remove("loading","start");
          filterCollectionVertical.classList.add("loaded", "finished");
          setTimeout(() => {
            filterCollectionVertical.classList.remove("loaded", "finished");
          }, 500);
        }
      }else{
        if (window.innerWidth > 1024) {
          filterCollection.classList.remove("loading","start");
          filterCollection.classList.add("loaded", "finished");
          setTimeout(() => {
            filterCollection.classList.remove("loaded", "finished");
          }, 500);
        }
      }
    }
    if (filterCollectionMobile) {
      filterCollectionMobile.classList.remove("loading","start");
      filterCollectionMobile.classList.add("loaded", "finished");
      setTimeout(() => {
        filterCollectionMobile.classList.remove("loaded", "finished");
      }, 500);
    }
    if (filterSearch) {
      if (window.innerWidth > 1024) {
        filterSearch.classList.remove("loading","start");
        filterSearch.classList.add("loaded", "finished");
        setTimeout(() => {
          filterSearch.classList.remove("loaded", "finished");
        }, 500);
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    /*
     * Filtrene skal opdateres som komplette, sammenhængende
     * wrappers. Mapping efter Shopifys forloop-indeks er ustabil,
     * fordi et filter kan forsvinde fra svaret og forskyde alle
     * efterfølgende indeks. Det var årsagen til duplikerede
     * Aromaterapi-/Olfactive character-grupper.
     */
    [
      {
        source:
          '#FacetFiltersForm #FacetsWrapperDesktop',
        target:
          '#FacetFiltersForm #FacetsWrapperDesktop'
      },
      {
        source:
          '#FacetFiltersFormMobile #FacetsWrapperMobile',
        target:
          '#FacetFiltersFormMobile #FacetsWrapperMobile'
      },
      {
        source:
          '#FacetFiltersPillsForm',
        target:
          '#FacetFiltersPillsForm'
      }
    ].forEach(({ source, target }) => {
      const sourceElement =
        parsedHTML.querySelector(source);

      const targetElement =
        document.querySelector(target);

      if (!sourceElement || !targetElement) {
        return;
      }

      targetElement.innerHTML =
        sourceElement.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(
      parsedHTML
    );

    actionFilter();

    window.enforceEsenseraFacetOrder?.();

    const latestSearchParams =
      FacetFiltersForm.searchParamsPrev ||
      window.location.search.slice(1);

    window.restoreBaseTypeSelection?.(
      latestSearchParams
    );

    window.applyEsenseraTypeSpecificFacetState?.(
      latestSearchParams
    );

    window.applyEsenseraDefaultFacetOpenState?.(
      latestSearchParams
    );

    window.updateTypeAvailability?.(
      latestSearchParams
    );

    window.updateAromaticProfileAvailability?.(
      latestSearchParams
    );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(
    searchParams,
    pathname = window.location.pathname
  ) {
    FacetFiltersForm.pathnamePrev =
      pathname;

    history.pushState(
      {
        searchParams,
        pathname
      },
      '',
      `${pathname}${
        searchParams
          ? '?'.concat(searchParams)
          : ''
      }`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

 createSearchParams(form) {
  const formData = new FormData(form);
  const searchParams = new URLSearchParams(formData);

  const currentSearchParams = new URLSearchParams(
    window.location.search
  );

  /*
   * På collection-sider repræsenteres Olfactive character
   * i collection-stien, så flere tags kan stackes med AND.
   * De må derfor ikke samtidig genindføres som storefront-
   * filterværdier, hvor værdier i samme gruppe bruger OR.
   */
  if (
    !document.querySelector(
      "[data-esensera-full-search-config]"
    )
  ) {
    searchParams.delete("filter.p.tag");
  }

  /*
   * På en Duftprofil-collection ligger Type som
   * filter.p.product_type i URL'en, men ikke som et normalt
   * felt i filterformularen. Bevar derfor Type-filteret,
   * når Note, Olfactive character, pris eller sortering ændres.
   */
  const isFilterForm =
  form.id === "FacetFiltersForm" ||
  form.id === "FacetFiltersFormMobile";

if (
  isFilterForm &&
  !searchParams.has("filter.p.product_type") &&
  currentSearchParams.has("filter.p.product_type")
) {
    currentSearchParams
      .getAll("filter.p.product_type")
      .forEach((value) => {
        searchParams.append(
          "filter.p.product_type",
          value
        );
      });
  }

  return searchParams.toString();
}

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
  event.preventDefault();

  const currentForm = event.target.closest("form");
  if (!currentForm) return;

  const isMobile =
    currentForm.id === "FacetFiltersFormMobile";

  const sortFilterForms = document.querySelectorAll(
    "facet-filters-form form"
  );

  const combinedParams = new URLSearchParams();

  /*
   * Tilføj en parameter, men undgå at tilføje
   * præcis samme key/value-kombination flere gange.
   *
   * Forskellige værdier med samme key bevares,
   * så almindelige multi-select-filtre stadig virker.
   */
  const appendUnique = (key, value) => {
    const existingValues = combinedParams.getAll(key);

    if (!existingValues.includes(value)) {
      combinedParams.append(key, value);
    }
  };

  sortFilterForms.forEach((form) => {
    const shouldIncludeForm = isMobile
      ? form.id === "FacetFiltersFormMobile"
      : (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetSortDrawerForm"
        );

    if (!shouldIncludeForm) return;

    const noJsElements =
      document.querySelectorAll(".no-js-list");

    noJsElements.forEach((element) => {
      element.remove();
    });

    const formParams = new URLSearchParams(
      this.createSearchParams(form)
    );

    formParams.forEach((value, key) => {
      appendUnique(key, value);
    });
  });

  /*
   * Aromaterapi er single-select. Capture-handleren i
   * facets-action.js rydder de øvrige checkboxes før dette
   * punkt; denne normalisering er et ekstra sikkerhedsnet for
   * gamle URL'er, browserhistorik og eventuelle skjulte inputs.
   */
  const aromatherapyParamName =
    "filter.p.m.custom.aromatherapy";

  const aromatherapyValues =
    combinedParams.getAll(
      aromatherapyParamName
    );

  if (aromatherapyValues.length > 1) {
    combinedParams.delete(
      aromatherapyParamName
    );

    combinedParams.set(
      aromatherapyParamName,
      aromatherapyValues[
        aromatherapyValues.length - 1
      ]
    );
  }

  this.onSubmitForm(
    combinedParams.toString(),
    event
  );
}

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.renderRequestId = 0;
FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);
FacetFiltersForm.pathnamePrev =
  window.location.pathname;

window.EsenseraFacetFiltersForm =
  FacetFiltersForm;

customElements.define(
  'facet-filters-form',
  FacetFiltersForm
);
FacetFiltersForm.setListeners();

class PriceRangeDrag extends HTMLElement {
  constructor() {
    super();
    this.adjustToValidValues();
  }
  countPercentMin(value) {
    const rangemax = this.dataset?.rangeMax;
    if (!rangemax || rangemax === 0) return;
    let from = 0;
    if (value || rangemax !== 0) {
      from = (value/rangemax)*100;
    }
    this.style.setProperty("--range-from", from+'%');
    if (Number(from) > Number(this.getValue("--range-to", this))) {
      this.style.setProperty("--range-to", from+'%');
    }
  }
  countPercentMax(value) {
    const rangemax = this.dataset?.rangeMax;
    if (!rangemax || rangemax === 0) return;
    let to = 0;
    if (value || rangemax !== 0) {
      to = (value/rangemax)*100;
    }
    this.style.setProperty("--range-to", to+'%');
    if (Number(this.getValue("--range-from", this)) > Number(to)) {
      this.style.setProperty("--range-from", to+'%');
    }
  }
  getValue(value, priceDrag) {
    var computedStyle = getComputedStyle(priceDrag);
    var fromValue = computedStyle.getPropertyValue(value);
    return fromValue.replace("%","");
  }

  adjustToValidValues() {
    const _this = this;
    var inputRange = this.querySelectorAll('input');
    var inputNum = this.closest("action-filter")?.querySelectorAll('price-range input');
    var rangeInput = inputRange[0];
    var rangeInput2 = inputRange[1];
    var minInput = inputNum[0];
    var maxInput = inputNum[1];
    
    rangeInput.addEventListener('input', function() {
      minInput.value = rangeInput.value;
      if (parseInt(minInput.value) > parseInt(maxInput.value)) {
        maxInput.value = Number(minInput.value);
        rangeInput2.value = Number(minInput.value);
      }
      _this.countPercentMin(Number(rangeInput.value));
    });
    
    rangeInput2.addEventListener('input', function() {
      maxInput.value = parseInt(rangeInput2.max) == rangeInput2.value ? Number(rangeInput2.max).toFixed(2) : rangeInput2.value;
      if (parseInt(maxInput.value) < parseInt(minInput.value)) {
        minInput.value = Number(maxInput.value);
        rangeInput.value = Number(maxInput.value);
      }
      if (parseInt(rangeInput2.max) == rangeInput2.value) {
        _this.countPercentMax(Number(rangeInput2.max));
      }else {
        _this.countPercentMax(Number(rangeInput2.value));
      }
    });
  }
}
customElements.define('price-range-drag', PriceRangeDrag);

class PriceRange extends PriceRangeDrag {
  constructor() {
    super();
    this.adjustToValidValues();
    this.priceDrag = this.closest("action-filter").querySelector('price-range-drag');
  }
  countPercentMin(value) {
    if (!this.priceDrag) return;
    const rangemax = this.priceDrag.dataset?.rangeMax;
    if (!rangemax || rangemax === 0) return;
    let from = 0;
    if (value || rangemax !== 0) {
      from = (value/rangemax)*100;
    }
    this.priceDrag.style.setProperty("--range-from", from+'%');
    if (Number(from) > Number(this.getValue("--range-to", this.priceDrag))) {
      this.priceDrag.style.setProperty("--range-to", from+'%');
    }
  }
  countPercentMax(value) {
    if (!this.priceDrag) return;
    const rangemax = this.priceDrag.dataset?.rangeMax;
    if (!rangemax || rangemax === 0) return;
    let to = 0;
    if (value || rangemax !== 0) {
      to = (value/rangemax)*100;
    }
    this.priceDrag.style.setProperty("--range-to", to+'%');
    if (Number(this.getValue("--range-from",this.priceDrag)) > Number(to)) {
      this.priceDrag.style.setProperty("--range-from", to+'%');
    }
  }
  adjustToValidValues() {
    const _this = this;
    var inputNum = this.querySelectorAll('input');
    var inputRange = this.closest("action-filter")?.querySelectorAll('price-range-drag input');
    var rangeInput = inputRange[0];
    var rangeInput2 = inputRange[1];
    var minInput = inputNum[0];
    var maxInput = inputNum[1];
    
    minInput.addEventListener('input', function() {
      if (minInput.value < Number(minInput.min) || minInput.value == "") {
        minInput.value = maxInput.min;
      }
      if (maxInput.value == "") {
        if (minInput.value > Number(maxInput.max)) {
          minInput.value = maxInput.max;
        }
      }else{
        if (minInput.value > Number(maxInput.value)) {
          minInput.value = maxInput.value;
        }
      }
      if (minInput.value != "") {
        rangeInput.value = minInput.value;
        _this.countPercentMin(Number(minInput.value));
      }
    });
    
    maxInput.addEventListener('input', function() {
      if (maxInput.value > Number(maxInput.max)) {
        maxInput.value = maxInput.max;
      }
      if (minInput.value == "") {
        if (maxInput.value < Number(minInput.min)) {
          maxInput.value = minInput.min;
        }
      }else{
        if (maxInput.value < Number(minInput.value)) {
          maxInput.value = minInput.value;
        }
      }
      if (maxInput.value != "") {
        rangeInput2.value = maxInput.value > maxInput.max ? Number(maxInput.max).toFixed(2) : maxInput.value;
        _this.countPercentMax(Number(maxInput.value));
      }else{
        rangeInput2.value = Number(maxInput.max).toFixed(2);
        _this.countPercentMax(Number(maxInput.max));
      }
    });
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetRemoveCanvas extends FacetRemove {
  constructor() {
    super();
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    const canvas = this.closest(".bls__canvas");
    setTimeout(() => {
      if (canvas) {
        rootAction.remove();
        canvas.classList.remove("active");
        canvas.removeAttribute("open");
        const details_tag = canvas.closest("details");
        if (details_tag) {
          setTimeout(() => {
            details_tag.removeAttribute("open");
          }, 300);
        }
      }
    }, 1000);
    removeTrapFocus(document.querySelector("[data-item='overlay-filter']"));
  }
}

customElements.define('facet-remove-canvas', FacetRemoveCanvas);

class FacetApplyCanvas extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.addEventListener('click', this.closeFilter.bind(this));
    this.addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
        _this.closeFilter.bind(_this)(event);
      }
    }.bind(_this), false);
  }

  closeFilter(event) {
    event.preventDefault();
    const canvas = this.closest(".bls__canvas");
    if (canvas) {
      rootAction.remove();
      canvas.classList.remove("active");
      canvas.removeAttribute("open");
      const details_tag = canvas.closest("details");
      if (details_tag) {
        setTimeout(() => {
          details_tag.removeAttribute("open");
        }, 300);
      }
      removeTrapFocus(document.querySelector("[data-item='overlay-filter']"));
    }
  }
}

customElements.define('facet-apply-canvas', FacetApplyCanvas);